import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-660f7dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form form" }
const _hoisted_5 = { style: {"margin":".7rem 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Cpu = _resolveComponent("Cpu")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_tree_view_component = _resolveComponent("tree-view-component")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_button_loading_component = _resolveComponent("button-loading-component")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_search_items_by_part_number_component = _resolveComponent("search-items-by-part-number-component")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingMode)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                    _createTextVNode(" Новая запчасть "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.ruleForm?.partNumber), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка запчасти "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.item?.partNumber), 1)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                model: _ctx.ruleForm,
                ref: "addUserForm",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Артикул",
                    "label-position": "top",
                    prop: "partNumber"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 23 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleForm.partNumber,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.partNumber) = $event)),
                                readonly: _ctx.isSearchByNumberLoading,
                                clearable: !_ctx.isSearchByNumberLoading,
                                maxlength: "255",
                                onClear: _ctx.onPartNumberClear,
                                onKeyup: _ctx.onPartNumberKeyup
                              }, null, 8, ["modelValue", "readonly", "clearable", "onClear", "onKeyup"])
                            ]),
                            _: 1
                          }),
                          (!_ctx.isManualFillingFormModeOn)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                span: 1,
                                align: "middle",
                                style: {"padding":"0.36rem 0px 0px 0.28rem"}
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.isSearchByNumberLoading)
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: "17",
                                        class: "is-loading"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Loading)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isSearchByNumberLoading)
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 1,
                                        size: "20",
                                        onClick: _cache[1] || (_cache[1] = () => _ctx.onPartNumberProcessClick(_ctx.ruleForm.partNumber)),
                                        class: _normalizeClass({'item-processor': true, 'disabled': _ctx.ruleForm.partNumber?.length < _ctx.itemNumberMinLength})
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Cpu)
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_col, {
                                key: 1,
                                span: 1,
                                align: "middle",
                                style: {"padding":"0.36rem 0px 0px 0.28rem"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, {
                                    size: "20",
                                    class: "item-processor disabled"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Cpu)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Наименование",
                    "label-position": "top",
                    prop: "externalName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.externalName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.externalName) = $event)),
                        maxlength: "255",
                        readonly: !_ctx.isManualFillingFormModeOn
                      }, null, 8, ["modelValue", "readonly"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Описание (внутреннее поле)",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.internalDescription,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.internalDescription) = $event)),
                        maxlength: "5000",
                        "show-word-limit": "",
                        type: "textarea",
                        placeholder: "Описание запчасти"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.isManualFillingFormModeOn)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "Производитель",
                        "label-position": "top",
                        prop: "manufacturerId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ruleForm.manufacturerId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.manufacturerId) = $event)),
                            placeholder: "Выберите из списка"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.manufacturers, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  value: item.value,
                                  label: item.label
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isManualFillingFormModeOn)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "Производитель",
                        "label-position": "top",
                        prop: "manualManufacturer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            filterable: "",
                            "allow-create": "",
                            modelValue: _ctx.ruleForm.manualManufacturer,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.manualManufacturer) = $event)),
                            placeholder: "Выберите из списка"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemManufacturers, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  value: item.id,
                                  label: item.name
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "Единица измерения",
                    "label-position": "top",
                    prop: "measureUnitId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleForm.measureUnitId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.measureUnitId) = $event)),
                        placeholder: "Выберите из списка"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemMeasureUnits, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              value: item.id,
                              label: item.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Группа",
                    "label-position": "top",
                    prop: "groupId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_tree_view_component, {
                        url: "/api/itemsgroups",
                        modelValue: _ctx.ruleForm.groupId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.groupId) = $event)),
                        "disable-root": true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.isManualFillingFormModeOn,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isManualFillingFormModeOn) = $event)),
                        "active-text": "Ручной ввод"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        (!_ctx.isCreatingMode)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: _ctx.onUpdateItemClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Сохранить ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_button_loading_component, {
                              key: 1,
                              loading: _ctx.isAsyncOperationPending,
                              label: "Создать",
                              onOnClick: _ctx.onCreateItemClick
                            }, null, 8, ["loading", "onOnClick"]))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _ctx.isAsyncOperationPending]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_search_items_by_part_number_component, {
      onItemSelected: _ctx.onInternalCatalogItemSelected,
      onClosed: _cache[9] || (_cache[9] = () => _ctx.itemsDialogVisible = false),
      items: _ctx.itemsDialogData,
      "part-number": _ctx.itemsDialogPartNumber,
      visible: _ctx.itemsDialogVisible
    }, null, 8, ["onItemSelected", "items", "part-number", "visible"])
  ], 64))
}